<template>
    <v-container>
        <v-row>
            <v-col>
                <v-select v-model="selected" :multiple="true" color="#c42111" :items="items" @change="onChange" :rules="[validation.min(selected, minSelected)]" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'MultiSelect',
    props: ['param'],
    data: () => ({
        selected: [],
        items: [],
        minSelected: 0,
        validation: {
            min: (selected, minSelected) => selected.length >= minSelected || `Min of ${minSelected} must be selected`
        }
    }),

    computed: {

    },

    methods: {
        onChange: function(val) {
            let selectedValue = '';
            for(let item of this.selected) {
                selectedValue += `${item}; `;
            }
            if(selectedValue.length) {
                selectedValue = selectedValue.slice(0, -2);
            }
            this.param.selectedValue = selectedValue;
            this.param.humanText = selectedValue.replace(/;/g, ',');

            this.$emit('edit');
        },

        buildList: function() {
            let preSelect = false;
            this.minSelected = parseInt(this.param.rpt_param_values[0]);
            for(let i = 1; i < this.param.rpt_param_values.length; i++) {
                let item = this.param.rpt_param_values[i];
                if(item == "") {
                    preSelect = true;
                }
                else {
                    if(preSelect) {
                        this.selected.push(this.items[parseInt(item)]);
                    }
                    else {
                        this.items.push(item);
                    }
                }
            }
        },

        setInputsInitialValue: function() {
            if(this.$props.param.encodedValue == undefined) {
                return;
            }
            let selectedItems = this.$props.param.encodedValue.split(';');
            selectedItems = selectedItems.map(s => s.trim());
            selectedItems.forEach(item => {
                item = item.trim();
            });
            this.selected = selectedItems;
        }
    },

    mounted() {
        this.buildList();
        this.setInputsInitialValue();
        this.onChange();
    }

  
};
</script>

<style scoped>


</style>

